import { DialogRendererProps } from "@/lib/dynamic-dialog/types";
import { Tables } from "@/lib/supabase/supabase_types_override";
import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { ValidatedCrmProject } from "../../hooks/lib/useValidateCrmProjects";
import { TabsValue } from "../../components/organisms/ImportConfigsDialog/ImportConfigsDialog";
import { EditedConfig, ImportConfigsDialogConfigurationParametersSchemaType } from "../../components/organisms/ImportConfigsDialog/types";

interface ImportConfigsDialogContextProps {
    rawFileData: Record<string,string>[] | null;
    setRawFileData: (data: Record<string,string>[] | null) => void;
    crm?: Tables<'crm'> | null;
    editedConfigId: string | null;
    setEditedConfigId: (id: string | null) => void;
    dialogProps: DialogRendererProps<unknown>;
    currentTab: TabsValue;
    setCurrentTab: Dispatch<SetStateAction<TabsValue>>;
    validatedProjects?: ValidatedCrmProject[];
    validateProjects: () => void;
    isLoadingValidateProjects: boolean;
    fileObjectKeyToPropertyMap?: ImportConfigsDialogConfigurationParametersSchemaType;
    setFileObjectKeyToPropertyMap: Dispatch<SetStateAction<ImportConfigsDialogConfigurationParametersSchemaType | undefined>>;
    detailsCrmConfigId: string | null;
    setDetailsCrmConfigId: Dispatch<SetStateAction<string | null>>;
    fileObjectKeys: string[];
    fileObjectExampleValues: string[];
    isEditedConfigCrmProject: boolean;
    editedConfig: EditedConfig | undefined;
}
export const importConfigsDialogContext = createContext<ImportConfigsDialogContextProps | undefined>(undefined);

export function useImportConfigsDialogContext() {
    const context = useContext(importConfigsDialogContext);
    if (!context) {
        throw new Error("useImportConfigsDialogContext must be used within ImportConfigsDialogContextProvider");
    }
    return context;
}